import { useMutation } from "@tanstack/react-query"

import { client } from "@/api"
import { CreateAdvertisementFormDataType } from "@/dialogs/advertisements/CreateAdvertisementDialog"

function useCreateAdvertisement() {
  return useMutation({
    mutationFn: (data: CreateAdvertisementFormDataType) => {
      return client
        .post(`/advertisements`, data)
        .then((response) => response.data)
    },
  })
}
export default useCreateAdvertisement
